import tw, { styled } from 'twin.macro';

export const StyledFooterSocialLink = styled.a`
  ${tw`block`}
  ${tw`w-[37px] h-[37px] rounded-lg p-1`}
  ${tw`bg-primary-p1`}
  ${tw`text-neutrals-n1`}
  ${tw`hover:bg-ui-colours-ui1`}
  ${tw`hover:text-primary-p1`}
  ${tw`hover:border-primary-p1`}
  ${tw`hover:border`}
`;

export const StyledLinkLabel = styled.span`
  ${tw`sr-only`}
`;
